
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(h|kk2|n)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
